import { put, call, select, takeEvery } from 'redux-saga/effects'
import {
	postsLoadRequest,
	postsLoadSuccess,
	postsLoadFailure
} from '../actions'

function* fetchPosts() {
	const hasPostsInState = yield select(state => !state.posts.items[0].shell)

	if (!hasPostsInState) {
		try {
			const response = yield call(() =>
				fetch(process.env.REACT_APP_DEV_WP_POSTS_URL + '&per_page=3')
			)
			const json = yield call(() => response.json())
			const payload = {
				posts: json.map(post => {
					let categories = post._embedded['wp:term'][0]
						.map(category => {
							return category.name
						})
						.join(', ')
					return {
						title: post.title.rendered,
						url: post.link,
						excerpt: post.excerpt.rendered,
						category: categories,
						author: {
							name: post._embedded.author[0].name,
							avatar: post._embedded.author[0].avatar_urls[96]
						}
					}
				}),
				receivedAt: Date.now()
			}
			yield put(postsLoadSuccess(payload))
		} catch (error) {
			yield put(postsLoadFailure({ error }))
		}
	}
}

export function* watchPostsRequest() {
	yield takeEvery(postsLoadRequest, fetchPosts)
}



// WEBPACK FOOTER //
// ./src/sagas/posts.js